import React from "react";
import LoginForm from "../components/user/loginForm";
import TopBar from "../components/topBar";

const Login = () => {
  return (
    <>
      <TopBar />
      <div className="mt-8 pt-8 mx-5">
        <h1 className="text-3xl mb-4 font-bold">Login</h1>
        <LoginForm />
      </div>
    </>
  );
};

export default Login;
